import { Badge, Col, Row } from "reactstrap";
import { BadgeTitle } from "../../../Constants/Constants";
import { BadgesData } from "../../../Data/Bonus/Elements";

const BadgeSection = () => {
  return (
    <section>
      <Row>
        {BadgesData.map((item, index) => (
          <Col className={item.class} key={index}>
            <div className="element-card">
              <div className="element-card-header heading">
                <h2>{BadgeTitle}</h2>
              </div>
              <div className="element-card-body typography">
                {item.data.map((badge, index) => (
                  <Badge key={index} color={badge.color} className={`${badge.className} font_label`}>
                    {badge.label}
                  </Badge>
                ))}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </section>
  );
};

export default BadgeSection;
